import React, { Component } from 'react';
import { connect } from 'react-redux';
import dayjs from '../../../dayjs/dayjs_timezone.js';
import { dateTimeFormat, timeFormatFromParams } from '../../utilities/timeUtility';
import ScrollBox from '../../components/ScrollBox';
import Translation from '../../utilities/localizationUtility';

const uniqSlots = (slots) => {
  const result = [];
  const map = new Map();
  for (const slot of slots) {
    if (!map.has(slot.id)) {
      map.set(slot.id, true);
      result.push(slot);
    }
  }
  return result;
};

const getSelectedTerm = (props) => {
  const { termId, terms, termSelected: termSelectedLegacy } = props;
  return (termId && terms?.find((term) => term.id === termId)) || termSelectedLegacy;
};

class Index extends Component {
  constructor(props) {
    super(props);

    this.state = {
      timeSlots: [],
      termSelected: props.termSelected,
    };
  }

  static getDerivedStateFromProps(nextProps, prevstate) {
    const { flattenTimeSlots, settings } = nextProps;
    const termSelected = getSelectedTerm(nextProps);

    let timeSlots = uniqSlots(flattenTimeSlots.filter((x) => x.term_id === termSelected.id));

    if (settings.setting
      && settings.setting.max_number_of_events
      && parseInt(settings.setting.max_number_of_events, 10)
      && timeSlots.length) {
      timeSlots = timeSlots.slice(0, parseInt(settings.setting.max_number_of_events, 10));
    }

    if (settings.setting
      && settings.setting.max_number_of_months
      && parseInt(settings.setting.max_number_of_months, 10)
      && timeSlots.length) {
      const firstSlot = timeSlots[0];
      const finishDate = dayjs(firstSlot.start).add(parseInt(settings.setting.max_number_of_months, 10), 'M');
      timeSlots = timeSlots.filter((x) => dayjs(x.start) < finishDate);
    }

    return { timeSlots, termSelected };
  }

  timeZone() {
    return this.props.settings.timeZone;
  }

  render() {
    const { settings } = this.props;
    const { timeSlots, termSelected } = this.state;
    const { region, setting } = settings;
    const t = new Translation(settings);
    const timeFormat = timeFormatFromParams(window.bta.locale, setting.time_format);

    return (
      <div className="classes-list-container">
        <p className="letter-spacing text-center fz13">
          {dayjs(termSelected.start_date).tz(this.timeZone()).locale(region).format(dateTimeFormat(true, false))}
          {' - '}
          {dayjs(termSelected.finish_date).tz(this.timeZone()).locale(region).format(dateTimeFormat(true, false))}
        </p>
        <ScrollBox height="100%" color={settings.style.body.color}>
          <ul style={{ padding: '5px 15px' }}>
            {timeSlots.length ? (
              timeSlots.map((x) => (
                <li
                  key={x.id}
                  className="flexbox space-between"
                  style={{
                    padding: '0 5px 10px',
                    opacity: dayjs(x.start).tz(this.timeZone()).isBefore() ? 0.6 : 1,
                    letterSpacing: '1px',
                    fontSize: '15px',
                    lineHeight: 1.5,
                  }}
                >
                  <span>{dayjs(x.start).tz(this.timeZone()).locale(region).format('ddd, MMM DD, YYYY')}</span>
                  <span>
                    {dayjs(x.startStr, 'YYYY-MM-DD HH:mm:ss Z').tz(this.timeZone()).locale(region).format(timeFormat)}
                    {' - '}
                    {dayjs(x.finishStr, 'YYYY-MM-DD HH:mm:ss Z').tz(this.timeZone()).locale(region).format(timeFormat)}
                  </span>
                </li>
              ))
            ) : (
              <li className="flexbox space-between text-center" style={{ padding: '5px' }}>
                {t.key('noClass')}
              </li>
            )}
          </ul>
        </ScrollBox>
      </div>
    );
  }
}

Index.propTypes = {};

export default connect(({ product, frames, order, settings }) => ({
  flattenTimeSlots: frames.flattenTimeSlots,
  termSelected: order.termSelected,
  terms: product?.data?.terms,
  settings,
}))(Index);
